import React from 'react'
import { useFinancialStatementsState } from '../../../../../features/financialStatements'
import IncomeStatementTable from '../../../../../features/financialStatements/components/StatementTable/IncomeStatementTable'
import { Loading } from '../../../../../components/Misc/Loading'
import { ModalProvider } from '../../../../../features/financialStatements/components/StatementTable/ModalContext'
import { DriverDataProvider } from '../../../../../features/driverData/context/DriverDataContext'
import { DeprecationPlanProvider } from '../../../../../features/deprecationPlan/context/DeprecationPlanContext'

interface IncomeStatementProps {
  // item: CompanyDashboardItem
  // width: number
  height: number
}

export const IncomeStatement: React.FC<IncomeStatementProps> = ({ height }: IncomeStatementProps) => {
  const {
    companyId,
    statementData,
    columns,
    statementLoading,
    statementFetching,
    financialStatementsFilters,
    dimensionMap,
    dimensionList,
    getDimensionParams
  } = useFinancialStatementsState(false) // false = not budgeting page

  const isLoading = statementLoading || statementFetching

  if (isLoading) return <Loading />
  if (!companyId) return <div>No company selected</div>

  return (
    <ModalProvider>
      <DriverDataProvider>
        <DeprecationPlanProvider>
          <div style={{ height, display: 'flex', flexDirection: 'column' }}>
            <IncomeStatementTable
              treeData={statementData?.incomeStatement ?? []}
              columns={columns}
              loading={isLoading}
              isBudgetingPage={false}
              companyId={companyId}
              financialStatementsFilters={financialStatementsFilters}
              dimensionMap={dimensionMap}
              dimensionList={dimensionList}
              getDimensionParams={getDimensionParams}
              hideControls
            />
          </div>
        </DeprecationPlanProvider>
      </DriverDataProvider>
    </ModalProvider>
  )
}
